// @flow

import * as types from '../ACTIONS/commonActionTypes';
import initialState from './commonInitialState';

export default function statsReducer(state = initialState.statsInfo, ourClientId:number, action) {

    switch (action.type) {
        case types.GET_STATSINFO_SUCCESS: {
            const statsInfo = action.statsInfo;
            return (statsInfo);
        }
        default:
            return(state);
    }
}

